import {runInAction} from 'mobx';

import type {AttachmentApiService} from '../../../../services/api/attachmentService/AttachmentApi.service';
import type {ApiWsEventModel} from '../../../../services/api/models/WsEvent/ApiWsEventModel';
import type {WSService} from '../../../../services/ws/wsService/WS.service';
import type {FileAttachmentModel} from '../FileAttachment.model';

import {AttachmentType} from '../../utils';

export class WSFileAttachmentManager {
  constructor(private attachment: FileAttachmentModel) {}

  async handleWsEvent(message: ApiWsEventModel) {
    const file = message.file;

    if (!file) {
      return;
    }

    /*
    // We convert all files, but we can read only file created by the current user

    const result = await this.attachmentApiService.readFileAttachment({
      fileId: file.id,
    });

    this.attachment.updateApiModel(result);
    */

    switch (message.type) {
      case 'audio_transcription_completed': {
        runInAction(() => {
          this.attachment.apiModel._update.field(
            'transcript',
            file.transcription,
          );
        });
        break;
      }
      case 'file_converted': {
        runInAction(() => {
          this.attachment.apiModel._update.field(
            'playableSrc',
            file.playableSrc,
          );
        });
        break;
      }
      default:
        return;
    }
  }

  registerToConvert() {
    const shouldRegister =
      this.attachment.attachmentType === AttachmentType.VOICE;

    if (shouldRegister) {
      this.wsService.registerFileToConvert(this.attachment);
    }
  }

  registerToTranscribe() {
    if (this.attachment.shouldRegisterToTranscribe) {
      this.wsService.registerFileToTranscribe(this.attachment);
    }
  }

  setAttachment(attachment: FileAttachmentModel) {
    this.attachment = attachment;

    return this;
  }

  unregister() {
    this.wsService.unregisterFileToConvert(this.attachment);
    this.wsService.unregisterFileToTranscribe(this.attachment);
  }

  private get attachmentApiService(): AttachmentApiService {
    return this.attachment.__injections.attachmentApiService;
  }

  private get wsService(): WSService {
    return this.attachment.__injections.wsService;
  }
}
